import { fromJS } from 'immutable';
import { ACTION_PREFIX } from '../constants/packagesConstants';

export const SET_SUBMITTED = `${ACTION_PREFIX}/SET_SUBMITTED`;

export const setSubmittedAction = (isSubmitted = true) => ({
  type: SET_SUBMITTED,
  isSubmitted,
});

export const initialState = fromJS({
  isSubmitted: false,
});

// eslint-disable-next-line default-param-last -- other order causes render issues
const formReducer = (state = initialState, action) => {
  switch (action && action.type) {
    case SET_SUBMITTED: {
      return state.set('isSubmitted', action.isSubmitted);
    }
    default:
      return state;
  }
};

export default formReducer;
